import { ProductResponse } from "../../../../types/product.type";
import PriceBookInfo from "./PriceBookInfo";
import ProductInfo from "./ProductInfo";

interface ProductDetailsProps {
  productDetails: ProductResponse;
  categoryName: string;
  canEdit: boolean;
  onEdit: () => void;
}

/** Two cards: everything about the product, then the pricebooks it is priced in. */
export default function ProductDetails({
  productDetails,
  categoryName,
  canEdit,
  onEdit,
}: ProductDetailsProps) {
  return (
    <>
      <ProductInfo
        productDetails={productDetails}
        categoryName={categoryName}
        canEdit={canEdit}
        onEdit={onEdit}
      />
      <PriceBookInfo productDetails={productDetails} />
    </>
  );
}
